import React from 'react'

import Skeleton from 'components_new/atoms/Skeleton'

import ThumbnailList from 'components_new/molecules/ThumbnailList'

const Loading = () => {
  return (
    <ThumbnailList itemSize={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 3 }}>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((item) => (
        <Skeleton key={item} variant="rounded" width={'100%'} height={240} />
      ))}
    </ThumbnailList>
  )
}

Loading.displayName = 'Loading'

export default Loading
